import { Fragment, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';
import { loaderActions } from "../../../_actions/loader.actions";
import "../../../assets/css/master.css";
import { getAllData, postUsersData, verifytoken } from '../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../commonClass/Session';

interface optionList {
    label: string;
    value: number;
}
interface dropdowndata {
    domainList: optionList[];
    travelAgentList: optionList[];
    corporetList: optionList[];
    roleList: optionList[];
    departmentList: optionList[];
}
class dropdowndataModal {
    domainList: optionList[];
    travelAgentList: optionList[];
    corporetList: optionList[];
    roleList: optionList[];
    departmentList: optionList[];

    constructor() {
        this.domainList = [];
        this.travelAgentList = [];
        this.corporetList = [];
        this.roleList = [];
        this.departmentList = [];
    }
}

class roleFormModal {
    DomainMasterId: number;
    TravelAgentId: number | null;
    CorporateId: number | null;
    RoleId: number;
    DepartmentId: number;

    constructor() {
        this.DomainMasterId = 0;
        this.TravelAgentId = null;
        this.CorporateId = null;
        this.RoleId = 0;
        this.DepartmentId = 0;
    }
}


const Rolerights = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [userrolerights, setUserRoleRights] = useState<any>([]);
    // const [roleList, setRoleList] = useState<any>([]);
    const [toggleRow, setToggleRow] = useState<any>([]);
    const user = useSelector((store: any) => store.userstatus.tba);
    const menuItem = useSelector((store: any) => store.menuitems.menu);
    const [useradd, setUserAdd] = useState(true);
    const [useredit, setUserEdit] = useState(true);

    const usertype = 3

    const [dropdownData, setDropdownData] = useState<dropdowndata>(new dropdowndataModal());

    const [AgencyId, setAgencyId] = useState(0);
    const [formValue, setFormValue] = useState(new roleFormModal())

    const AgencyList = useMemo(() => {
        if (formValue?.DomainMasterId > 1) {
            return formValue?.DomainMasterId === 2 ? dropdownData?.travelAgentList : formValue?.DomainMasterId === 3 ? dropdownData?.corporetList : []
        }
        else {
            return [];
        }

    }, [dropdownData, formValue?.DomainMasterId])

    const selectRoleList: any = useMemo(() => {
        if (formValue?.DepartmentId > 0) {
            const selectedDepartment: any = dropdownData.departmentList.find((fill: any) => fill.value === formValue.DepartmentId)
            return selectedDepartment?.RoleList ? JSON.parse(selectedDepartment?.RoleList) : []
        }
        else {
            return [];
        }

    }, [formValue?.DepartmentId])



    const getmorolerightsoptions = async () => {
        const morolerightsoptions = await getAllData(`/auth/v1/getmorolerightsoptions?UserType=${usertype}`)

        if (morolerightsoptions?.status) {
            setDropdownData(morolerightsoptions?.data)
        }
        else {
            setDropdownData((prev) => ({ ...prev, domainList: [], corporetList: [], travelAgentList: [], roleList: [] }))
        }
    }

    const getmouserroledetailbyroleid = async (roleid: number) => {
        setUserRoleRights([]);
        const payload = {
            DomainMasterId: roleid > 0 ? formValue?.DomainMasterId : 0,
            TravelAgentId: roleid > 0 ? formValue?.TravelAgentId : null,
            CorporateId: roleid > 0 ? formValue?.CorporateId : null,
            UserType: usertype ? usertype : 3,
            RoleId: roleid,
        }
        const mouserroledetailbyroleid = await postUsersData("/auth/v1/getmouserroledetailbyroleid", payload)
        if (mouserroledetailbyroleid?.status) {
            setUserRoleRights(mouserroledetailbyroleid?.data);
            let pagelink = user?.find((x: any) => {
                if (x?.PageLink === window.location.pathname)
                    return x?.MenuId
            });
            let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
            if (mid?.URightView === false && mid?.URightView !== undefined) {
                navigate('/dashboard');
            }
            user?.filter((x: any) => x?.MenuId === pagelink?.MenuId).map((obj: any) => {
                setUserAdd(obj?.URightAdd);
                setUserEdit(obj?.URightEdit);

            });
        }
    }

    useEffect(() => {
        async function fetchData() {
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                Promise.allSettled([
                    getmouserroledetailbyroleid(0),
                    getmorolerightsoptions()
                ])
            }
            else {
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
            }
        }
        fetchData()
    }, [])


    const handleSelectChange = (name: string, value: number) => {
        if (name === "DomainMasterId") {
            setAgencyId(0);
            setFormValue((form) => ({ ...form, DomainMasterId: value, TravelAgentId: null, CorporateId: null, RoleId: 0 }));
        }
        else if (name === "AgencyId") {
            setAgencyId(value);
            setFormValue((form) => ({
                ...form,
                TravelAgentId: form?.DomainMasterId === 2 ? value : null,
                CorporateId: form?.DomainMasterId === 3 ? value : null,
                RoleId: 0
            }));
        } else if (name === 'DepartmentId') {
            setFormValue((form) => ({ ...form, [name]: value, RoleId: 0 }));
            getmouserroledetailbyroleid(0)
        }
        else {
            setFormValue((form) => ({ ...form, [name]: value }));
            getmouserroledetailbyroleid(value)
            setUserRoleRights([]);
        }
    }

    const handleExpandAdmin = (e: any) => {
        const doesExist = toggleRow.includes(e);
        if (doesExist === false) {
            setToggleRow((current: any) => [...current, e]);
        }
        else {
            setToggleRow((oldState: any) => oldState?.filter((item: any) => item !== e));

        }
    }

    // const getRoleList = async () => {
    //     let statusoftoken = await verifytoken();
    //     if (statusoftoken) {
    //         await getAllData('/auth/v1/bindroleslist?UserType=' + usertype).then((roledata) => {
    //             if (roledata?.status) {
    //                 setRoleList(roledata.data?.map((el: any) => ({
    //                     label: el.label,
    //                     value: el.value
    //                 })))
    //             }
    //         })
    //     }
    //     else {
    //         ClearLocalStorage();
    //         dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    //     }
    // }

    // const getRoleById = async (roleid: number = 0) => {
    //     let statusoftoken = await verifytoken();
    //     if (statusoftoken) {
    //         setUserRoleRights([]);
    //         dispatch(loaderActions.start());
    //         await getAllData('/auth/v1/getmouserroledetailbyroleid?roleid=' + roleid + "&UserType=" + usertype).then((roledata) => {
    //             if (roledata.status) {
    //                 setUserRoleRights(roledata.data);
    //                 let pagelink = user?.find((x: any) => {
    //                     if (x?.PageLink === window.location.pathname)
    //                         return x?.MenuId
    //                 });
    //                 let mid = user?.find((x: any) => x?.MenuId === pagelink?.MenuId);
    //                 if (mid?.URightView === false && mid?.URightView !== undefined) {
    //                     navigate('/dashboard');
    //                 }
    //                 user?.filter((x: any) => x?.MenuId === pagelink?.MenuId).map((obj: any) => {
    //                     setUserAdd(obj?.URightAdd);
    //                     setUserEdit(obj?.URightEdit);

    //                 });
    //             }
    //         })
    //     }
    //     else {
    //         ClearLocalStorage();
    //         dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
    //     }
    //     dispatch(loaderActions.end());
    // }


    const handlesavadata = async () => {
        let statusoftoken = await verifytoken();
        if (statusoftoken) {
            const savedata = {
                DomainMasterId: formValue?.DomainMasterId,
                TravelAgentId: formValue?.TravelAgentId,
                CorporateId: formValue?.CorporateId,
                RoleId: formValue?.RoleId,
                MoUserRolesRightsList: userrolerights,
            }
            const UserData = await postUsersData("/auth/v1/insertorupdatemorolesrights", savedata);
            if ((!UserData.status && UserData.data === null) || (!UserData.status && !UserData.data)) {
                dispatch({ type: 'ALERTING', message: UserData.message })
            }
            else {
                if (UserData.status && UserData.data > 0) {
                    dispatch({ type: 'ALERTING', message: UserData.message })
                    handleClearClick();
                }
                else {
                    dispatch({ type: 'ALERTING', message: UserData.message })
                    handleClearClick();
                }
            }
            dispatch(loaderActions.end());
        }
        else {
            ClearLocalStorage();
            dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' })
        }
        dispatch(loaderActions.end());

    }

    const handleChangeCheck = (
        menuList: any[],
        targetMenuId: number,
        newRoleAddValue: boolean,
        type: string,
    ): any => {
        if (formValue?.RoleId === 0) {
            // dispatch(alertActions.error('please select Role'));
        }
        else {
            const updateMenuList = (list: any[]): any[] => {
                return list?.map(item => {
                    const newItem = { ...item };

                    // Recursively update children
                    if (newItem.children && newItem.children.length > 0) {
                        newItem.children = updateMenuList(newItem.children);
                    }

                    // If this is the target item, update the permission
                    if (newItem.menu_Id === targetMenuId) {
                        switch (type) {
                            case 'uRoleView':
                            case 'uRoleAdd':
                            case 'uRoleEdit':
                            case 'uRoleExport':
                                newItem[type] = newRoleAddValue;
                                // If any permission is false, set uRoleAll = false
                                if (newItem.uRoleAll && !newRoleAddValue) {
                                    newItem.uRoleAll = false;
                                }
                                break;

                            case 'uRoleAll':
                                newItem.uRoleAll = newRoleAddValue;
                                newItem.uRoleView = newRoleAddValue;
                                newItem.uRoleAdd = newRoleAddValue;
                                newItem.uRoleEdit = newRoleAddValue;
                                newItem.uRoleExport = newRoleAddValue;
                                break;
                        }
                    }

                    // Update uRoleAll based on individual permissions
                    const { uRoleView, uRoleAdd, uRoleEdit, uRoleExport } = newItem;
                    newItem.uRoleAll = uRoleView && uRoleAdd && uRoleEdit && uRoleExport;

                    return newItem;
                });
            };
            const updatedTree = updateMenuList(menuList);
            setUserRoleRights(updatedTree); // Your state update
            return updatedTree;
        }
    };


    const handleClearClick = () => {
        getmouserroledetailbyroleid(0);
        setFormValue((form) => ({
            ...form,
            DomainMasterId: 0,
            TravelAgentId: null,
            CorporateId: null,
            DepartmentId: 0,
            RoleId: 0,
        }))
        setAgencyId(0);
    }


    const renderRows = (items: any[], tempcol: any[], level: number = 0) => {
        return items?.map(item => {
            const isExpanded = toggleRow?.includes(item?.menu_Id);
            const hasChildren = item?.children?.length > 0;

            if (item?.menuType === 1) {
                return (
                    <Fragment key={item?.menu_Id}>
                        <tr>
                            <th
                                className='admin_btn'
                                style={{ width: "275px", paddingLeft: `${13 * (level + 1)}px` }}
                                onClick={() => handleExpandAdmin(item?.menu_Id)}
                                scope="row"
                            >
                                <i
                                    className={`fa fa-angle-${isExpanded ? 'down rotet' : 'down'} me-1`}
                                    aria-hidden="true"
                                ></i>
                                {item?.pageTitle}
                            </th>
                            <td colSpan={5}></td>
                        </tr>

                        {isExpanded && hasChildren && renderRows(item?.children, tempcol, level + 1)}
                    </Fragment>
                );
            }

            if (item?.menuType === 0) {
                return (
                    <tr key={item?.menu_Id}>
                        <th style={{ width: "275px", paddingLeft: `${14 * (level + 2)}px` }} scope="row">{item?.pageTitle}</th>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRoleAll}
                                name="All"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRoleAll, 'uRoleAll')}
                                type='checkbox'
                                value="All"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRoleView}
                                name="View"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRoleView, 'uRoleView')}
                                type='checkbox'
                                value="View"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRoleAdd}
                                name="Add"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRoleAdd, 'uRoleAdd')}
                                type='checkbox'
                                value="Add"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRoleEdit}
                                name="Edit"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRoleEdit, 'uRoleEdit')}
                                type='checkbox'
                                value="Edit"
                            />
                        </td>
                        <td>
                            <input
                                className="form-check-input"
                                checked={item?.uRoleExport}
                                name="Export"
                                onChange={(e) => handleChangeCheck(tempcol, item?.menu_Id, !item?.uRoleExport, 'uRoleExport')}
                                type='checkbox'
                                value="Export"
                            />
                        </td>
                    </tr>
                );
            }
            return null;
        });
    }


    return (
        <>
            <div className="mx-2 mt-0 mb-3 heading_color">
                <h2 className='fw-bold'>{menuItem?.[0]?.pageTitle}</h2>
            </div>
            <div className="m-2 heading_color">
                <h4>{menuItem?.[1]?.pageTitle} </h4>
            </div>
            <div className="m-2">
                <form action="" className='mt-3' >
                    <div className="mb-3 row mx-1">
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="row">
                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="DomainMasterId" className="col-form-label required">Select Domain</label>
                                        </div>
                                        <div className="col-xl-12 col-lg-8 col-md-12 col-sm-12">
                                            <Select
                                                inputId='DomainMasterId'
                                                className="dropdown custom_class select_dropdown"
                                                options={dropdownData?.domainList}
                                                value={dropdownData?.domainList?.filter((fil) => fil?.value === formValue?.DomainMasterId)}
                                                onChange={(e: any) => handleSelectChange("DomainMasterId", e?.value)}
                                                isDisabled={formValue?.RoleId > 0 ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="AgencyId" className={`col-form-label ${formValue?.DomainMasterId > 1 ? 'required' : ''} `}>Select Agency</label>
                                        </div>
                                        <div className="col-xl-12 col-lg-8 col-md-12 col-sm-12">
                                            <Select
                                                inputId='AgencyId'
                                                className="dropdown custom_class select_dropdown"
                                                options={AgencyList}
                                                value={AgencyList?.filter((fil) => fil?.value === AgencyId)}
                                                onChange={(e: any) => handleSelectChange("AgencyId", e?.value)}
                                                isDisabled={formValue?.DomainMasterId <= 1 || formValue?.RoleId > 0 ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="RoleId" className="col-form-label required">Select Department</label>
                                        </div>
                                        <div className="col-xl-12 col-lg-8 col-md-12 col-sm-12">
                                            <Select
                                                inputId='DepartmentId'
                                                className="dropdown custom_class select_dropdown"
                                                options={dropdownData?.departmentList}
                                                value={dropdownData?.departmentList?.filter((fil: any) => fil?.value === formValue?.DepartmentId)}
                                                onChange={(e: any) => handleSelectChange("DepartmentId", e?.value)}
                                                isDisabled={formValue?.DomainMasterId === 0 || (formValue?.DomainMasterId > 1 && AgencyId === 0) ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-3 mb-lg-1'>
                                    <div className='row'>
                                        <div className="col-xl-12 col-lg-4 col-md-12 col-sm-12">
                                            <label htmlFor="RoleId" className="col-form-label required">Select Role</label>
                                        </div>
                                        <div className="col-xl-12 col-lg-8 col-md-12 col-sm-12">
                                            <Select
                                                inputId='RoleId'
                                                className="dropdown custom_class select_dropdown"
                                                options={selectRoleList}
                                                value={selectRoleList?.filter((fil: any) => fil?.value === formValue?.RoleId)}
                                                onChange={(e: any) => handleSelectChange("RoleId", e?.value)}
                                                isDisabled={formValue.DepartmentId <= 0}
                                            // isDisabled={formValue?.DomainMasterId === 0 || (formValue?.DomainMasterId > 1 && AgencyId === 0) ? true : false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 row">
                        <div className='overflow-auto'>
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th className='ps-4' scope="col">Title</th>
                                        <th scope="col">All</th>
                                        <th scope="col">View</th>
                                        <th scope="col">Add</th>
                                        <th scope="col">Edit</th>
                                        <th scope="col">Export</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {renderRows(userrolerights, userrolerights)}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center">
                        {(useradd === true || useredit === true) ?
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handlesavadata} disabled={formValue?.RoleId > 0 ? false : true} >Save</button>
                            :
                            <button type="button" className="btn btn-primary mx-1" id="btnAdd" onClick={handlesavadata} disabled={true} >Save</button>}
                        <button type="button" className="btn btn-primary mx-1" id="btnClear" onClick={handleClearClick}>Clear</button>
                    </div>
                </form >
            </div >
        </>
    )
}

export default Rolerights